import styled from 'styled-components';

/** How long the suggested plan takes: the one number the modal is for. */
export const Duration = styled.div`
  font-size: 28px;
  font-weight: 700;
  line-height: 1.15;
  color: ${({ theme }) => theme.darkGray};
`;

/*
 * The figures in the modal: the suggested methods, the comparison and the
 * months. A grid rather than the shared TableHeader: short static columns
 * that must stay lined up on a phone, where TableHeader hides itself. The
 * label column takes the room it needs, the value columns share the rest and
 * read right-aligned like amounts.
 */
export const FigureRow = styled.div<{ $columns: number; $strong?: boolean }>`
  display: grid;
  grid-template-columns: minmax(96px, 1.3fr) repeat(
      ${({ $columns }) => $columns},
      minmax(0, 1fr)
    );
  align-items: baseline;
  gap: 8px;
  padding: 8px 0;
  font-weight: ${({ $strong }) => ($strong ? 700 : 'inherit')};

  & + & {
    border-top: ${({ theme }) => theme.borders.border1};
  }

  > :not(:first-child) {
    text-align: right;
    overflow-wrap: anywhere;
  }

  @media (max-width: 800px) {
    grid-template-columns: minmax(80px, 1.2fr) repeat(
        ${({ $columns }) => $columns},
        minmax(0, 1fr)
      );
    gap: 6px;
  }
`;

export const BulletList = styled.ul`
  margin: 0;
  padding-left: 18px;

  li {
    font-size: 14px;
    line-height: 1.5;
    color: ${({ theme }) => theme.darkGray};

    & + li {
      margin-top: 6px;
    }
  }
`;

/** The row that opens and closes the details: the whole line is the target. */
export const DetailsToggle = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 0;
  border: none;
  background: none;
  cursor: pointer;
  color: inherit;
  text-align: left;
`;
